import AsyncStorage from '@react-native-async-storage/async-storage'

const PENDING_PHONE_FORWARDING_GUIDE_KEY = 'relayably.dashboard.pending-phone-forwarding-guide'

const browserStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }

  return null
}

export const phoneForwardingGuideStorage = {
  async clearPending() {
    const storage = browserStorage()

    if (storage) {
      storage.removeItem(PENDING_PHONE_FORWARDING_GUIDE_KEY)
      return
    }

    await AsyncStorage.removeItem(PENDING_PHONE_FORWARDING_GUIDE_KEY)
  },

  async getPendingWorkspaceId() {
    const storage = browserStorage()

    if (storage) {
      return storage.getItem(PENDING_PHONE_FORWARDING_GUIDE_KEY)
    }

    return AsyncStorage.getItem(PENDING_PHONE_FORWARDING_GUIDE_KEY)
  },

  async setPendingWorkspaceId(workspaceId: string) {
    const storage = browserStorage()

    if (storage) {
      storage.setItem(PENDING_PHONE_FORWARDING_GUIDE_KEY, workspaceId)
      return
    }

    await AsyncStorage.setItem(PENDING_PHONE_FORWARDING_GUIDE_KEY, workspaceId)
  },
}
